import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { VirtualPhoto } from './components/VirtualPhoto';
import { Museum } from './components/Museum';
import { ExperienceBanner } from './components/ExperienceBanner';
import { Visit } from './components/Visit';
import { Footer } from './components/Footer';

/**
 * The whole single-page site. A fixed galactic backdrop (nebula gradient) sits
 * behind a fixed header, the scrolling content, and the footer.
 */
export const App = () => (
  <>
    <div className="galaxy" aria-hidden="true" />
    <Header />
    <main id="top">
      <Hero />
      <Stats />
      <VirtualPhoto />
      <Museum />
      <ExperienceBanner />
      <Visit />
    </main>
    <Footer />
  </>
);
